export default __webpack_public_path__ + "407b6c3f53f2989aaceb4588dacca8a1.png";